import * as React from "react";
import { forwardRef } from "react";
const SvgI = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 30.01 180", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("style", null, "\n      .cls-1 {\n        fill: #203b5e;\n      }\n    ")), /* @__PURE__ */ React.createElement("rect", { className: "cls-1", x: 0, y: 2.49, width: 30.01, height: 175 }));
const ForwardRef = forwardRef(SvgI);
export { ForwardRef as ReactComponent };
